'use client';
import '@vtmn-play/css/component/VpButton.css';

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { VpPoly } from '../../utils/VpPoly.mjs';
import { VpButtonContext } from './button-context.mjs';
import { VpButtonContent } from './VpButtonContent.mjs';
import { useVpButton } from './useVpButton.mjs';
import { mergeProps } from '@vtmn-play/utils';

const VpButton = forwardRef((props, ref) => {
  const {
    api,
    spreadableProps,
    frameworkProps: { asChild, as, children, startSlot, endSlot, loadingSlot }
  } = useVpButton(props);
  return /* @__PURE__ */ jsx(VpButtonContext.Provider, { value: { api }, children: /* @__PURE__ */ jsx(
    VpPoly,
    {
      asChild,
      ref,
      ...mergeProps(api.getRootProps(), spreadableProps),
      as,
      children: asChild ? children : /* @__PURE__ */ jsx(
        VpButtonContent,
        {
          startSlot,
          endSlot,
          loadingSlot,
          children
        }
      )
    }
  ) });
});

export { VpButton };
